export const POLYGON_COLOR = '#EBC03F';
